module.exports = "/images/ant.png?8f0698d436a05e29e361b858dbbcb2ea";